import { render, staticRenderFns } from "./IpClassCardManage.vue?vue&type=template&id=2072a580&scoped=true&"
import script from "./IpClassCardManage.vue?vue&type=script&lang=js&"
export * from "./IpClassCardManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2072a580",
  null
  
)

export default component.exports